import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["title"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon iconfont icon-miezzassign" }, null, -1)
const _hoisted_10 = {
  key: 1,
  style: {"width":"100% !important","word-break":"break-all","text-align":"left"}
}
const _hoisted_11 = { class: "link" }
const _hoisted_12 = { class: "link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_order_warehouse_assign = _resolveComponent("order-warehouse-assign")!
  const _component_order_pool_choose_service = _resolveComponent("order-pool-choose-service")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_page_list, {
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleTopButtonClick: _ctx.handleTopButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick
    }, {
      column: _withCtx(({ model,row }) => [
        (model.Prop == 'SigningTime')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              title: row.SigningTimeString
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.isString(row.SigningTimeString)), 1)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true),
        (model.Prop == 'Status')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (row.Status==20)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "部分交货"))
                : (row.Status==30)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "全部交货"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, "待交货"))
            ]))
          : _createCommentVNode("", true),
        (model.Prop == 'JoinCompanyUser')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                title: row.JoinCompanyUser.Name
              }, [
                (_ctx.OrderManagement_PurchaseOrder_AssignExecutor==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onAssigner(row)),
                      style: {"cursor":"pointer","width":"100% !important","word-break":"break-all","text-align":"left","color":"#fe995b"}
                    }, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.isString(row.JoinCompanyUser.Name)), 1)
                    ], 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.isString(row.JoinCompanyUser.Name)), 1))
              ], 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ]),
      "dynamic-search-customize": _withCtx(({ model }) => [
        (model.Where.Prop == 'DynamicSearch_UserId')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 0,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.users
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : _createCommentVNode("", true),
        (model.Where.Prop == 'DynamicSearch_Status')
          ? (_openBlock(), _createBlock(_component_miezz_select, {
              key: 1,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              options: _ctx.EnumOrderWarehouseStatusOption,
              number: true
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
          : _createCommentVNode("", true),
        (model.Where.Prop == 'DynamicSearch_Partner')
          ? (_openBlock(), _createBlock(_component_el_autocomplete, {
              key: 2,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              clearable: true,
              style: {"width":"100% !important"},
              "fetch-suggestions": _ctx.querySearchPartnerAsync,
              "popper-class": "my-autocomplete",
              placeholder: "请填写关键词",
              onSelect: ($event: any) => (_ctx.handleSelectPartner($event,model))
            }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(item.Label), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect"]))
          : _createCommentVNode("", true),
        (model.Where.Prop == 'DynamicSearch_Address')
          ? (_openBlock(), _createBlock(_component_el_autocomplete, {
              key: 3,
              modelValue: model.Where.Value,
              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
              clearable: true,
              style: {"width":"100% !important"},
              "fetch-suggestions": _ctx.querySearchAddressAsync,
              "popper-class": "my-autocomplete",
              placeholder: "请填写关键词",
              onSelect: ($event: any) => (_ctx.handleSelectAddress($event,model))
            }, {
              default: _withCtx(({ item }) => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.Label), 1)
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onHandleGet", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick"]),
    _createVNode(_component_order_warehouse_assign, {
      ref: "Assigner",
      onOnSelectOrderWarehouseAssigner: _ctx.onSelectOrderWarehouseAssigner
    }, null, 8, ["onOnSelectOrderWarehouseAssigner"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalChooseService,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalChooseService) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_order_pool_choose_service, {
          modelValue: _ctx.modalChooseService,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalChooseService) = $event)),
          orderWarehouseId: _ctx.id,
          code: _ctx.orderCode,
          clientCompanyId: _ctx.clientCompanyId,
          clientUserId: _ctx.clientUserId,
          onHandleSubmit: _ctx.handleChooseServiceSubmit
        }, null, 8, ["modelValue", "orderWarehouseId", "code", "clientCompanyId", "clientUserId", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}